import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';
import { AdminGuard } from 'src/auth/guard/admin-guard';

// ----------------------------------------------------------------------

// Overview

const SubscriptionPage = lazy(() => import('src/pages/subscription'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const subscriptionRoutes = [
  {
    path: '/subscription',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [{ element: <AdminGuard><SubscriptionPage /></AdminGuard>, index: true }],
  },
];
